import { StoreProductType } from '../../../../shared/store/BaseColonistStoreProduct.ts';
import { UIAjaxWrapper } from '../network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../network/UIAPIEndpoints.ts';
import { showSimpleDialog } from '../ui_popup/showSimpleDialog.ts';
import { navigateToPage } from '../ui_utils/ClientUtils.ts';
export class UICheckoutAjaxEndPoints {
    static async executeStripeColonistProductPurchaseSession(storeProductType, type, itemQuantity = 1) {
        const url = `${UIAPIEndpoints.apiPayGetStoreStripeSession()}/${storeProductType}/${type}/${itemQuantity}`;
        const response = await UIAjaxWrapper.postRequestHandler(url, undefined, undefined);
        if (response == undefined) return;
        void this.gotCheckoutSession(response.json);
    }
    static async executeStripeColonistGiftPurchaseSession(purchaseType, giftPurchaseData) {
        const storeProductType = StoreProductType.OneTimePurchase;
        const url = `${UIAPIEndpoints.apiPayGetStoreStripeSession()}/${storeProductType}/${purchaseType}/${giftPurchaseData.duration}`;
        const response = await UIAjaxWrapper.postRequestHandler(url, undefined, giftPurchaseData);
        if (response == undefined) return;
        void this.gotCheckoutSession(response.json);
    }
    static async fetchStripePaymentClientSecret(storeProductType, type, itemQuantity = 1, giftPurchaseData) {
        const url = `${UIAPIEndpoints.apiPayGetStripePaymentClientSecret()}/${storeProductType}/${type}/${itemQuantity}`;
        const response = await UIAjaxWrapper.postRequestHandler(url, undefined, giftPurchaseData);
        if (response == undefined) return undefined;
        return response.json;
    }
    static gotCheckoutSession(response) {
        var _response_session;
        if (!response.status) {
            showSimpleDialog({
                title: {
                    key: 'strings:storePage.errors.fail'
                },
                body: response.message
            });
            return;
        }
        const checkoutUrl = (_response_session = response.session) === null || _response_session === void 0 ? void 0 : _response_session.url;
        if (checkoutUrl == undefined) {
            showSimpleDialog({
                title: {
                    key: 'strings:storePage.errors.fail'
                },
                body: {
                    key: 'strings:storePage.errors.fail'
                }
            });
            return;
        }
        navigateToPage(checkoutUrl);
    }
    static async executeXsollaColonistCoinPurchaseSession(storeProductType, type) {
        const url = `${UIAPIEndpoints.apiPayGetStoreXsollaSession()}/${storeProductType}/${type}`;
        const response = await UIAjaxWrapper.postRequestHandler(url, undefined, undefined);
        if (response == undefined) return;
        navigateToPage(response.json);
    }
    static async executeStripeCustomerPortalSession() {
        const response = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiPayCreateCustomerPortalSession(), undefined, undefined);
        if (response == undefined) return;
        navigateToPage(response.json);
    }
}
